module.exports = __webpack_public_path__ + "static/media/Perfomancereporting.bad5feee.svg";